// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"ben_a bfq_um bfq_cw bfq_a","MenuItem__Btn":"ben_b bfq_z"};